import { createContext } from 'react'

const ValidFieldNamesContext = createContext<readonly string[]>([])

export default ValidFieldNamesContext
